var _g;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
class IconMsWordLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMsWord",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _g || (_g = _jsxs("g", {
        fillRule: "evenodd",
        children: [_jsx("path", {
          d: "M1251.654 0c44.499 0 88.207 18.07 119.718 49.581l329.223 329.224c31.963 31.962 49.581 74.54 49.581 119.717V1920H169V0Zm-66.183 112.941H281.94V1807.06h1355.294V564.706H1185.47V112.94Zm112.94 23.379v315.445h315.445L1298.412 136.32Z"
        }), _jsx("path", {
          d: "M959.588 338.824v451.764H507.824V338.824h451.764zm-112.94 112.94H620.764v225.883h225.882V451.765zm-338.824 564.707h903.529V903.529h-903.53zm0 451.764h790.588v-112.94H507.824zm0-225.882h677.647v-112.941H507.824z"
        })]
      }))
    });
  }
}
IconMsWordLine.glyphName = 'ms-word';
IconMsWordLine.variant = 'Line';
IconMsWordLine.displayName = 'IconMsWordLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMsWordLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMsWordLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMsWordLine;
export { IconMsWordLine };